import { render, staticRenderFns } from "./EtiquetaForm.vue?vue&type=template&id=06174fa2"
import script from "./EtiquetaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EtiquetaForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports